module.exports = __webpack_public_path__ + "static/media/maleWhite.e7c696d0.svg";